/**
 * FeedbackLink
 * "Something not right?" link for reporting issues with AI-generated content
 */

import { makeStyles, tokens, Link } from '@fluentui/react-components'
import { ChatWarningRegular } from '@fluentui/react-icons'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    marginTop: tokens.spacingVerticalM,
    paddingTop: tokens.spacingVerticalS,
    borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  icon: {
    fontSize: '14px',
    color: tokens.colorNeutralForeground3,
  },
  link: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
    ':hover': {
      color: tokens.colorBrandForeground1,
    },
  },
})

export interface FeedbackLinkProps {
  context?: string
  onClick?: () => void
}

export function FeedbackLink({ context, onClick }: FeedbackLinkProps) {
  const styles = useStyles()

  const handleClick = () => {
    if (onClick) {
      onClick()
    } else {
      // Default behavior - could open a feedback dialog
      console.log('Feedback requested for context:', context)
    }
  }

  return (
    <div className={styles.root}>
      <ChatWarningRegular className={styles.icon} />
      <Link className={styles.link} onClick={handleClick}>
        Something not right? Let us know
      </Link>
    </div>
  )
}
